import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {

  @Input() openDialog: boolean;
  @Input() header: string;
  @Input() closeButtonText = 'vbeiClose';

  @Output() openDialogChange: EventEmitter<boolean> = new EventEmitter();
  @Output() closeEvent: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
  }

  confirmCloseClick(): void {
    this.closeEvent.emit();
  }

  resetDialog() {
    this.openDialogChange.emit(false);
  }
}
